import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Checkbox, Form, Input } from 'antd';
import PhoneInput from 'antd-phone-input';
import css from '@/pages/Login/Login.module.scss';

import LoginWrapper from '../LoginWrapper';

import { AUTH_TYPES } from '@shared/pages/Login/constants';
import { clearError, registrUserLogin } from '@shared/store/Auth/actions';
import { selectAuth } from '@shared/store/Auth/selectors';
import { validatePassword } from '@shared/utils/password-patterns';

const RegisterMobile = () => {
  const { t } = useTranslation('registration');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error: errorText } = useSelector(selectAuth);

  const [acceptPrivacy, setAcceptPrivacy] = useState(false);

  // const ldapLogin = providersTypes.includes(AUTH_TYPES.LDAP);

  const isKampus = document.location.hostname === 'td.kampus.team';

  const handleSubmit = ({ phone, password }) => {
    const sendData = {
      phone: `+${phone?.countryCode}${phone?.areaCode}${phone?.phoneNumber}`,
      password,
    };

    dispatch(
      registrUserLogin(sendData, resp => {
        localStorage.setItem('registrData', JSON.stringify(sendData));
        navigate(`/user-login/mobile-registration/${resp.messageId}`, { replace: true });
      })
    );
  };

  const mobileValidator = (_, { valid }) => {
    if (valid(true)) return Promise.resolve();
    return Promise.reject(t('rules.phone'));
  };

  const handleChange = (value, event) => {
    dispatch(clearError());
  };

  return (
    <LoginWrapper type='registr'>
      <Form className={css['LoginPage-form']} layout='vertical' onFinish={handleSubmit}>
        {/* Номер телефона */}
        <Form.Item
          className={css['LoginPage-form-item']}
          name='phone'
          validateTrigger='onBlur'
          validateStatus={errorText?.length > 0 ? 'error' : 'success'}
          help={errorText?.length > 0 && errorText}
          rules={[{ required: true, validator: mobileValidator }]}
        >
          <PhoneInput
            placeholder={t('placeholders.phone')}
            preferredCountries={['ru', 'by']}
            enableSearch
            disableParentheses
            onChange={handleChange}
          />
        </Form.Item>

        {/* Пароль */}
        <Form.Item
          className={css['LoginPage-form-item']}
          name='password'
          rules={[
            { required: true, message: t('rules.password') },
            // {
            //   validator: (_, value) => {
            //     if (
            //       validatePassword(ldapLogin, true, value, res => {
            //         return res >= 3;
            //       })
            //     ) {
            //       return Promise.resolve();
            //     }
            //     return Promise.reject(ldapLogin ? new Error(t('passwordWrongLdap')) : new Error(t('passwordWrong')));
            //   },
            // },
          ]}
        >
          <Input.Password className={css['LoginPage-form-item-password']} placeholder={t('placeholders.password')} />
        </Form.Item>

        {isKampus && (
          <Form.Item className={css['LoginPage-form-checkbox']}>
            <Checkbox checked={acceptPrivacy} onChange={() => setAcceptPrivacy(!acceptPrivacy)} />
            &nbsp; Нажимая на кнопку, вы даете согласие на обработку персональных данных, а также соглашаетесь с &nbsp;
            <a href='https://kampus.team/privacy'>политикой конфиденциальности</a>
          </Form.Item>
        )}

        {/* Кнопка регистрации */}
        <Form.Item className={css['LoginPage-form-google']}>
          <Button size='large' type={'primary'} htmlType='submit' disabled={isKampus ? !acceptPrivacy : false}>
            {t('singUp')}
          </Button>
        </Form.Item>
      </Form>
    </LoginWrapper>
  );
};

export default RegisterMobile;
